import React, {useEffect, useRef, useState, memo} from "react";
import PropTypes from 'prop-types';
import {Tooltip} from "antd";

const TextTooltip = ({ message, dontShow, children, altMessage, ...props }) => {
    const [show, SetShow] = useState(false);

    const ref = useRef(null);

    const Text = React.cloneElement(children, {
        ...props,
        ref,
    });

    useEffect(() => {
        const element = ref.current;

        if (!element) {
            return;
        }

        const {offsetWidth, scrollWidth} = element;

        offsetWidth < scrollWidth ? SetShow(true) : SetShow(false);
    }, [ref, children]);

    if (dontShow) {
        return children;
    }

    return (
        <Tooltip
            title={show ? message : altMessage}
            placement="top"
            overlayClassName="tooltip_custom"
        >
            {Text}
        </Tooltip>
    );
};
TextTooltip.defaultProps = {
    altMessage: ''
}
TextTooltip.propTypes = {
    message: PropTypes.string.isRequired,
    dontShow: PropTypes.bool,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]),
    altMessage: PropTypes.string,
}
export default memo(TextTooltip);
